var _circle, _circle2, _circle3, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamWebcam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.66
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.6953,
    cy: 60.4023,
    r: 60,
    fill: "url(#paint0_radial_1209_34104)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 60.6953,
    cy: 60.4023,
    r: 32,
    fill: "#7551FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 60.6953,
    cy: 60.4023,
    r: 35.6048,
    stroke: "#7551FF",
    strokeWidth: 0.790345
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.3594 52.537C72.9594 52.2703 72.426 52.2703 72.026 52.537L66.1594 56.537V53.737C66.1594 52.2703 64.9594 51.0703 63.4927 51.0703H50.026C48.5594 51.0703 47.3594 52.2703 47.3594 53.737V67.0703C47.3594 68.537 48.5594 69.737 50.026 69.737H63.3594C64.826 69.737 66.026 68.537 66.026 67.0703V64.2703L71.8927 68.2703C72.1594 68.4036 72.426 68.537 72.6927 68.537C72.9594 68.537 73.0927 68.537 73.3594 68.4036C73.7594 68.137 74.026 67.737 74.026 67.2036V53.737C74.026 53.2036 73.7594 52.8036 73.3594 52.537ZM63.3594 67.0703H50.026V53.737H63.3594V59.0703V61.737V67.0703ZM71.3594 64.537L66.026 60.937V59.737L71.3594 56.137V64.537Z",
    fill: "#7551FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1209_34104",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.6953 60.4023) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#610CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#080015",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamWebcam);
export default __webpack_public_path__ + "static/media/TeamWebcam.f2b17556e2ac68479ea12b4d0ea5d3f6.svg";
export { ForwardRef as ReactComponent };